import { Divider, Grid, InputAdornment } from '@mui/material';
import { add } from 'date-fns';
import { useFormContext } from 'react-hook-form';
import { AdditionalExportsMultipleSelect } from 'components/ExportsPanel/ExportSelect/AdditionalExportsMultipleSelect';
import { AdditionalExportsSelect } from 'components/ExportsPanel/ExportSelect/AdditionalExportsSelect';
import {
  RHFApiAutocomplete,
  RHFDatePicker,
  RHFNumberTextField,
  RHFSelect,
  RHFTextField,
} from 'components/form';

import { apiGeo } from 'constants/api';
import { SubscriptionLevelOptions, UserType, UserTypology } from 'constants/users';

const InspectorForm = () => {
  const { watch } = useFormContext();
  /*   const { user } = useAuthSelector();
  const watchTipologiaUtente = watch('tipologiaUtente'); */

  /* useEffect(() => {
    watchTipologiaUtente === 2
      ? setValue('email-utente-principale', user?.email)
      : setValue('email-utente-principale', null);
  }, [watchTipologiaUtente]); */

  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={12}>
        <Divider>INFORMAZIONI AZIENDA</Divider>
      </Grid>
      {watch('tipologiaUtente') &&
        watch('tipologiaUtente') === UserTypology.UtentePrincipale && (
          <>
            <Grid item xs={6}>
              <RHFTextField label="Ente / Società" name="businessName" />
            </Grid>
            <Grid item xs={3}>
              <RHFTextField label="Telefono" name="phone" />
            </Grid>
            <Grid item xs={3}>
              <RHFTextField label="C.F./P.IVA" name="fiscalCode" />
            </Grid>
            <Grid item xs={3}>
              <RHFApiAutocomplete
                name="region"
                label={'Regione'}
                endpoint={`${apiGeo.ROOT}${apiGeo.REGIONS}?`}
                getOptionLabel={option =>
                  option?.label && option?.value ? `${option?.label}` : option
                }
              />
            </Grid>

            <Grid item xs={3}>
              <RHFApiAutocomplete
                name="province"
                label={'Provincia'}
                endpoint={`${apiGeo.ROOT}${apiGeo.PROVINCES}?parentId=${
                  watch('region')?.value?.id
                }`}
                getOptionLabel={option =>
                  option?.label && option?.value ? `${option?.label}` : option
                }
                disabled={!watch('region')}
              />
            </Grid>
            <Grid item xs={3}>
              <RHFApiAutocomplete
                name="council"
                label={'Comune'}
                endpoint={`${apiGeo.ROOT}${apiGeo.COUNCILS}?parentId=${
                  watch('province')?.value?.id
                }`}
                getOptionLabel={option =>
                  option?.label && option?.value ? `${option?.label}` : option
                }
                disabled={!watch('province')}
              />
            </Grid>
            <Grid item xs={3}>
              <RHFTextField label="Indirizzo" name="address" />
            </Grid>
            <Grid item xs={12}>
              <Divider>SOTTOSCRIZIONE</Divider>
            </Grid>
            <Grid item xs={3}>
              <RHFDatePicker
                label="Data scadenza"
                name="expirationDate"
                minDate={add(new Date(), {
                  days: 1,
                })}
              />
            </Grid>
            <Grid item xs={3}>
              <RHFTextField
                decimalScale={0}
                label="Max Nr. Opere"
                name="maxStructureNumber"
              />
            </Grid>
            <Grid item xs={3}>
              <RHFNumberTextField
                label="Max Spazio Disponibile (GB)"
                name="maxAvailableSpace"
                decimalScale={0}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">GB</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <RHFSelect
                label="Livello di sottoscrizione"
                name="level"
                defaultValue={''}
                selectOptions={SubscriptionLevelOptions}
              />
            </Grid>
            {/* Abilita per questo utente principale, ed estende a tutti i
            suoi collaboratori interni (ExportSelect.jsx, via
            GET users/me/additional-exports — Task 34), un set di
            esportazioni normalmente non previste per la sua
            tipologia/sottoscrizione — solo quelle che un Professionista non
            ha già di default (AdditionalExportsSelect). */}
            <Grid item xs={6}>
              <AdditionalExportsSelect userType={UserType.Professionista} />
            </Grid>
            {/* Campo separato per l'export MULTIPLO dalla sezione ponti
            (ExportStructuresPanel.jsx/StructuresList.jsx, pulsante "Esporta
            Elenco Ponti") — oggi inaccessibile di default a un
            Professionista (il pannello è Ente-only): tutte e 5 le voci sono
            quindi sempre potenziali candidate, campo abilitato (a
            differenza di InstitutionForm.jsx/Ente). */}
            <Grid item xs={6}>
              <AdditionalExportsMultipleSelect />
            </Grid>
          </>
        )}
      {watch('tipologiaUtente') &&
        watch('tipologiaUtente') === UserTypology.CollaboratoreInterno && (
          <Grid item xs={3}>
            <RHFTextField
              label="Email Utente Principale*"
              name="emailUtentePrincipale"
            />
          </Grid>
        )}
    </Grid>
  );
};

export default InspectorForm;
